import { color } from 'framer-motion';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addAboutUs, onAddInputLocation, onAddZipCodeLocation, onDeleteLocation } from '../../features/appSlice';
import classes from './AboutUs.module.css';
import MapContainer from './MapContainer';
const AboutUs = (props) => {
	const state = useSelector((state) => state);
	// console.log(props.data, 'AboutUs')
	const aboutdata = state.app.contextData.about_us;
	const dispatch = useDispatch();
	const onchangeAbout = (event, index) => {
		dispatch(addAboutUs([event.target.value, index]));
	}
	const leadRadius = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

	const addLocation = (e) => {
		e.preventDefault();
		dispatch(onAddZipCodeLocation());
	}

	const deleteLocation = (index) => {
		dispatch(onDeleteLocation(index));
	}

	const handleZipcodeinput = (event, index, type) => {
		let val = event.target.value;
		if (type === 'zipcode') {
			val = val.replace(/[^\d]*/gi, "");
			if (val.length > 5) {
				return;
			}
		}
		dispatch(onAddInputLocation([val, index, type]))
	}
	return (
		<div className={`tab-pane fade ${(props.activeTab === 3) && 'show active'}`} id="aboutus" role="tabpanel" aria-labelledby="aboutus-tab">
			<div className='col-md-12'>
				<div className='row'>
					<h2 className='box-title'>About Us</h2>
					<div className='col-md-7'>
						{/* <div>{props.dataUrls}</div> */}
						{props?.data ?

							<>

								{props?.data.map((item, i) => (
									<div className='form-group' >
										<label className={`row ${classes.aboutus_lable}`}>
											<div className='col-md-12'>
												<span>{item.q}</span>
											</div>


										</label>
										<textarea className={`form-control ${classes.inputTextare}`}
											value={item.a}
											onChange={(e) => onchangeAbout(e, i)} >
										</textarea>
									</div>

								))
								}
							</> : <>
								{aboutdata.map((item, i) => (
									<div className='form-group' >
										<label className={`row ${classes.aboutus_lable}`}>
											<div className='col-md-12'>
												<span>{item.q}</span>
											</div>

											{/* <div className='col-md-4 text-right'>
										<button
											className={`button_stock ${classes.aboutus_skipbutton}`}
										>
											<span className={`${classes.skipbutton}`}>Skip this question</span>
										</button>
									</div> */}
										</label>
										<textarea className={`form-control ${classes.inputTextare}`}
											value={item.a}
											onChange={(e) => onchangeAbout(e, i)} >
										</textarea>
									</div>
								))}
							</>
						}
					</div>

					<div className='col-md-5'>
						<div className='card p-4'>
							<div className='row'>
								<h2 className='box-title'>Service Area Rules</h2>
							</div>
							<div className='row'>
								<label className='fw-bold'>Add zip code rules</label>
							</div>
							{state.app.contextData.zipcoderules && state.app.contextData.zipcoderules.map((zipcoderule, i) => (
								<div className='' key={i.toString()}>
									<div className='form-group'>
										<label className='send_leadwithin_lable'>Zip code {i > 0 &&
											<i
												className='fa fa-trash fa-sm'
												style={{ color: 'red', float: 'right', cursor: 'pointer' }}
												onClick={() => deleteLocation(i)}
											></i>
										}</label>
										<input
											className='form-control form-control-sm'
											value={zipcoderule.zipcode}
											onChange={(e) => handleZipcodeinput(e, i, 'zipcode')}
										/>
									</div>
									<div className='form-group'>
										<label>Send Lead Within
										</label>
										<select
											className='form-select form-select-sm'
											onChange={(e) => handleZipcodeinput(e, i, 'willing')}
										>
											<option value="">Select</option>
											{leadRadius.map((mile) => (
												<option selected={(zipcoderule.willing_travel == mile) ? true : false} value={mile} key={mile.toString()}>{mile} Miles</option>
											))}
										</select>
									</div>

								</div>
							))}

							<a href='' className='mb-2' onClick={addLocation} style={{ display: 'inline', textDecoration: 'none' }}> +Click to add locations</a>
							<div className='row m-0'>
								<div className='col-md-12 form-group p-0' style={{ height: 400 }}>
									{state.app.contextData.zipcoderules &&
										<MapContainer
											mapdata={state.app.contextData.zipcoderules}
										/>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AboutUs